import { call, put, takeLatest } from "redux-saga/effects"
import * as api from "./api"

// Events Redux States
import {
  GET_CLUBS_LEADS,
  GET_CLUB_LEAD_INFO,
  GET_CLUBS_LEADS_LOCATIONS,
} from "./actionTypes"

import {
  apiError,
  getClubsLeadsSuccess,
  getClubLeadInfoSuccess,
  getClubLeadsLocationsSuccess,
  getClubsLeadsError,
  getClubLeadsLocationsError,
} from "./actions"

function* getClubsLeadsLocations({ filters }) {
  try {
    const { data } = yield call(api.getClubsLeadsLocations, filters)
    yield put(getClubLeadsLocationsSuccess(data))
  } catch (error) {
    yield put(getClubLeadsLocationsError())
  }
}

function* getClubsLeads({ filters, options }) {
  try {
    const { data } = yield call(api.getClubsLeads, filters, options)
    yield put(getClubsLeadsSuccess(data))
  } catch (error) {
    yield put(getClubsLeadsError())
  }
}

function* getClubLeadInfo({ id }) {
  try {
    const { data } = yield call(api.getClubLeadInfo, id)
    yield put(getClubLeadInfoSuccess(data))
  } catch (error) {
    yield put(apiError({ status: error.response?.status || 0 }))
  }
}

function* eventsSaga() {
  yield takeLatest(GET_CLUBS_LEADS_LOCATIONS, getClubsLeadsLocations)
  yield takeLatest(GET_CLUBS_LEADS, getClubsLeads)
  yield takeLatest(GET_CLUB_LEAD_INFO, getClubLeadInfo)
}

export default eventsSaga
